import { Button, Modal } from "antd";
import styled from "styled-components";
import { ModalHeader } from 'datastake-daf/dist/components';

const Style = styled.div`
  p {
    font-size: 12px;
    color: #667085;
    line-height: var(--size);
    font-weight: 500;
    margin-bottom: var(--size-lg);
  }

  .buttons {
    display: flex;
    gap: 10px;

    .ant-btn {
      border-radius: 4px;
      flex: 1;

      &.danger {
        background: #F04438;
        color: white;
      }
    }
  }
`;

export default function DeleteModal({
  namespace = '',
  t = (s) => s,
  onClose = () => { },
  onSubmit = () => { },
  visible = false,
}) {
  const _render = () => {
    switch (namespace) {
      case 'project':
        return (
          <p>
            {t('Are you sure you want to delete this project? This action cannot be undone.')}
          </p>
        )
      default:
        return null;
    }
  };

  return (
    <Modal
      footer={null}
      width={330}
      open={visible}
      onCancel={onClose}
      title={(
        <ModalHeader
          title={t('Delete')}
        />
      )}
    >
      <Style>
        {_render()}
        <div className="buttons">
          <Button size="large" onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button
            size="large"
            type="link"
            className="danger"
            onClick={onSubmit}
          >
            {t('Delete')}
          </Button>
        </div>
      </Style>
    </Modal>
  )
}
